@use '../../styles/tokens' as *;

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 450px;
}

.datepickerWrapper {
  display: block;
  width: 100%;
}

:global(.react-datepicker__day--selected),
:global(.react-datepicker__day--keyboard-selected) {
  background-color: $utility-blue !important;
  border-radius: 999px !important;
}

.fileBox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.fileName,
.filePlaceholder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// Matches the ::placeholder colour the sibling text inputs use.
.filePlaceholder {
  color: #ababab;
}

.fileInput {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

// ----- Collapsed summary -----
.summaryList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
}

.summaryRow {
  display: flex;
  flex-direction: column;
  gap: 2px;

  dt {
    @include text-13;
    color: $base-4;
  }

  dd {
    margin: 0;
    @include text-body-2;
    font-weight: 600;
    color: $black;
  }
}
